/**
 * Promote-student dialog — hoist the class + section.
 */
import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ArrowUp } from "@phosphor-icons/react";

export function PromoteDialog({ open, onOpenChange, student, form, setForm, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Promote {student?.name}</DialogTitle>
          <DialogDescription>
            Currently in Class {student?.class_name}{student?.section ? `-${student.section}` : ""} · Roll {student?.roll_number || "—"}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <Label>Promote to class *</Label>
            <Input
              data-testid="promote-to-class"
              required
              value={form.to_class}
              onChange={(e) => setForm({ ...form, to_class: e.target.value })}
              className="bg-white"
              placeholder="e.g. 9"
            />
          </div>
          <div>
            <Label>Section <span className="text-[10px] text-[var(--vs-text-secondary)] font-normal">(optional)</span></Label>
            <Input
              data-testid="promote-to-section"
              value={form.section}
              onChange={(e) => setForm({ ...form, section: e.target.value })}
              className="bg-white"
              placeholder="e.g. A"
            />
          </div>
          <p className="text-[11px] text-[var(--vs-text-secondary)]">
            Audit trail records the promotion. Existing marksheets and progress reports remain attached to the student record.
          </p>
          <Button data-testid="confirm-promote" type="submit" className="bg-[var(--vs-secondary)] hover:bg-[var(--vs-secondary-hover)] text-[var(--vs-bg)] w-full">
            <ArrowUp size={14} className="mr-1.5" /> Promote
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
